import http from '../utils/request'

/**
 * 消息中心接口
 * 对应后端 MessageController (/api/message)
 */

// ============ 消息管理 ============

/**
 * 获取消息列表
 * @param {Object} params - { pageIndex, pageSize, keyword, isRead }
 * @returns {Promise}
 */
export const getMessages = (params = {}) => {
  return http.get('/message/list', { params })
}

/**
 * 获取未读消息列表
 * @param {Object} params - { pageIndex, pageSize }
 * @returns {Promise}
 */
export const getUnreadMessages = (params = {}) => {
  return http.get('/message/unread', { params })
}

/**
 * 获取私信列表
 * @param {Object} params - { pageIndex, pageSize }
 * @returns {Promise}
 */
export const getPrivateMessages = (params = {}) => {
  return http.get('/message/private', { params })
}

/**
 * 获取消息详情
 * @param {number} id - 消息ID
 * @returns {Promise}
 */
export const getMessageDetail = (id) => {
  return http.get(`/message/${id}`)
}

/**
 * 发送消息
 * @param {Object} data - { receiveAccount, title, content, msgType }
 * @returns {Promise}
 */
export const sendMessage = (data) => {
  return http.post('/message/send', data)
}

/**
 * 标记为已读
 * @param {string} ids - 消息ID，多个用逗号分隔
 * @returns {Promise}
 */
export const markMessagesAsRead = (ids) => {
  return http.put(`/message/read/${ids}`)
}

/**
 * 全部标记为已读
 * @returns {Promise}
 */
export const markAllAsRead = () => {
  return http.put('/message/read/all')
}

/**
 * 删除消息
 * @param {string} ids - 消息ID，多个用逗号分隔
 * @returns {Promise}
 */
export const deleteMessages = (ids) => {
  return http.delete(`/message/${ids}`)
}

/**
 * 获取消息统计数据
 * @returns {Promise}
 */
export const getMessageStats = () => {
  return http.get('/message/stats')
}

/**
 * 获取最近会话列表
 * @param {number} limit - 返回数量限制
 * @returns {Promise}
 */
export const getRecentConversations = (limit = 10) => {
  return http.get('/message/conversations', { params: { limit } })
}
